<template>
  <!--==================
		Dashboard component shows all statistics in both operator and admin page
		===============-->

  <div>
    <div class="container-fluid">
      <div v-if="user.role == 'operator'" class="alert alert-light" role="alert">
        <h4 class="alert-heading">Information<span class="badge badge-danger ml-2">In developing</span></h4>
        <p>
          We have paused your tours and company listing because your SafariTrekBeach's account ran out of money. You can
          reactivate your tours and company listing by adding enough funds to regain a positive balance.
        </p>
        <hr />
        <p class="mb-0">
          Your SafariTrekBeach's account ran out of money. Please add enough funds to regain a positive balance.
        </p>
      </div>
      <!-- last user login time -->
      <p class="text-right text-gray-800"><i class="icofont-history"></i> Last login: {{ lastLogin }}</p>
    </div>

    <div class="row">
      <!-- Request per booking -->
      <a class="col-xl-4 col-md-6 mb-4" href="javascript:void(0)">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body pb-0">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">REQUESTS PER BOOKING</div>
                <!-- <div class="h3 mb-0 font-weight-bold text-gray-800">{{ reviews.aproved + reviews.new }}</div> -->
              </div>
              <!-- <div class="col-auto"> -->
              <!-- <i class="icofont-cart icofont-3x text-gray-800"></i> -->
              <!-- </div> -->
            </div>
            <div class="row no-gutters position-relative mt-0 justify-content-center" style="margin-bottom: -20px">
              <vue-gauge
                :refid="'request'"
                :options="{
                  needleValue: 1,
                  arcDelimiters: [1],
                  rangeLabel: ['0', '10'],
                  chartWidth: 180,
                  arcPadding: 0,
                  centralLabel: '0.0',
                }"
              ></vue-gauge>
            </div>
            <hr class="row" />
            <div class="row no-gutters">
              <p class="mb-0 small text-muted">How many requests you needed to obtain a booking.</p>
            </div>
          </div>
        </div>
      </a>

      <!-- Costs -->
      <a class="col-xl-4 col-md-6 mb-4" href="javascript:void(0)">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body pb-0">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">COSTS</div>
                <!-- <div class="h3 mb-0 font-weight-bold text-gray-800">$ 412</div> -->
              </div>
              <div class="col-auto">
                <i class="icofont-dollar icofont-3x text-gray-800"></i>
              </div>
            </div>
            <div class="row no-gutters position-relative mt-0 justify-content-center">
              <h1 class="fw-bolder mt-4">$ 0.00</h1>
            </div>
            <hr class="row" />
            <div class="row no-gutters">
              <p class="mb-0 small text-muted">The amount you paid for the quote requests you received.</p>
            </div>
          </div>
        </div>
      </a>

      <!-- BOOKED REVENUE -->
      <a class="col-xl-4 col-md-6 mb-4" href="javascript:void(0)">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body pb-0">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">BOOKED REVENUE</div>
                <!-- <div class="h3 mb-0 font-weight-bold text-gray-800">€ 8,015</div> -->
              </div>
              <div class="col-auto">
                <i class="icofont-money icofont-3x text-gray-800"></i>
              </div>
            </div>
            <div class="row no-gutters position-relative mt-0 justify-content-center">
              <h1 class="fw-bolder mt-4">$ 0.00</h1>
            </div>
            <hr class="row" />
            <div class="row no-gutters">
              <p class="mb-0 small text-muted">The revenue you generated from the 'booked' requests.</p>
            </div>
          </div>
        </div>
      </a>

      <!-- operator statistics -->
      <a v-if="user.role == 'admin'" class="col-xl-4 col-md-6 mb-4" href="/dashboard/operators">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body pb-0">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Operators</div>
                <div class="h3 mb-0 font-weight-bold text-gray-800">
                  {{ operators.active + operators.inactive + operators.new + operators.delete }}
                </div>
              </div>
              <div class="col-auto">
                <i class="icofont-business-man-alt-1 icofont-3x text-gray-800"></i>
              </div>
            </div>
            <div class="row no-gutters position-relative mt-2">
              <span class="status active pr-4" title="registered operators and are shown on site"
                ><b>{{ operators.active }}</b> Active</span
              >
              <span class="status inactive pr-4" title="registered operators and are not shown on the site"
                ><b>{{ operators.inactive }}</b> Inactive</span
              >
              <span class="status unproved pr-4" title="new registered operators"
                ><b>{{ operators.new }}</b> New</span
              >
              <span class="status unproved pr-4" title="deleted operators"
                ><b>{{ operators.delete }}</b> Deleted</span
              >
            </div>
            <hr class="row" />
            <div class="row no-gutters">
              <p class="mb-0 small text-muted">The number of operators registered and their status</p>
            </div>
          </div>
        </div>
      </a>

      <!-- Booked -->
      <a class="col-xl-4 col-md-6 mb-4" href="/dashboard/reviews">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body pb-0">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Reviews</div>
                <div class="h3 mb-0 font-weight-bold text-gray-800">{{ reviews.aproved + reviews.new }}</div>
              </div>
              <div class="col-auto">
                <i class="icofont-edit icofont-3x text-gray-800"></i>
              </div>
            </div>
            <div class="row no-gutters position-relative mt-2">
              <span class="status proved pr-4" title="reviews that are available to operator's packages"
                ><b>{{ reviews.aproved }}</b> Aproved</span
              >
              <span class="status unproved pr-4" title="new written reviews to operator's packages"
                ><b>{{ reviews.new }}</b> New</span
              >
            </div>
            <hr class="row" />
            <div class="row no-gutters">
              <p class="mb-0 small text-muted">The number of reviews written and their status</p>
            </div>
          </div>
        </div>
      </a>

      <!-- package statistics -->
      <a class="col-xl-4 col-md-6 mb-4" :href="user.role == 'admin' ? '/dashboard/packages' : '/dashboard/tour'">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body pb-0">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Packages</div>
                <div v-if="user.role == 'admin'" class="h3 mb-0 font-weight-bold text-gray-800">
                  {{ tours.active + tours.inactive + tours.unproved + tours.suspended + tours.new + tours.trash }}
                </div>
                <div v-if="user.role == 'operator'" class="h3 mb-0 font-weight-bold text-gray-800">
                  {{ tours.active + tours.inactive + tours.unproved }}
                </div>
              </div>
              <div class="col-auto">
                <i class="icofont-panther icofont-3x text-gray-800"></i>
              </div>
            </div>
            <div class="row no-gutters position-relative mt-2">
              <span v-if="user.role == 'admin'" class="status inactive pr-4" title="packages that are new"
                ><b>{{ tours.new }}</b> New
              </span>
              <span class="status active pr-4" title="packages that are available to site"
                ><b>{{ tours.active }}</b> Active
              </span>
              <span class="status inactive pr-4" title="packages that are not available to site"
                ><b>{{ tours.inactive }}</b> Inactive
              </span>
              <span class="status unproved pr-4" title="packages that are not aproved to be on site"
                ><b>{{ tours.unproved }}</b> Unproved
              </span>
              <span
                v-if="user.role == 'admin'"
                class="status unproved pr-4"
                title="packages that are not aproved to be on site"
                ><b>{{ tours.suspended }}</b> Suspended
              </span>
              <span
                v-if="user.role == 'admin'"
                class="status unproved pr-4"
                title="packages that are deleted or operator is deleted"
                ><b>{{ tours.trash }}</b> Trashed
              </span>
            </div>
            <hr class="row" />
            <div class="row no-gutters">
              <p class="mb-0 small text-muted">The number of packages added and their status</p>
            </div>
          </div>
        </div>
      </a>

      <!-- quote statistics -->
      <a class="col-xl-4 col-md-6 mb-4" href="/dashboard/quotes">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body pb-0">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Quote Requests</div>
                <div class="h3 mb-0 font-weight-bold text-gray-800">
                  {{ quotes.booked + quotes.notbooked + quotes.stillopen }}
                </div>
              </div>
              <div class="col-auto">
                <i class="icofont-envelope icofont-3x text-gray-800"></i>
              </div>
            </div>
            <div class="row no-gutters position-relative mt-2">
              <span class="status booked pr-4" title="quotes that are booked"
                ><b>{{ quotes.booked }}</b> Booked</span
              >
              <span class="status notbooked pr-4" title="quotes that are not booked"
                ><b>{{ quotes.notbooked }}</b> Not Booked</span
              >
              <span class="status stillopen pr-4" title="quotes that are still open"
                ><b>{{ quotes.stillopen }}</b> Still Open</span
              >
            </div>
            <hr class="row" />
            <div class="row no-gutters">
              <p class="mb-0 small text-muted">The number of requests received and their booking status</p>
            </div>
          </div>
        </div>
      </a>

      <!-- blog statistics -->
      <a v-if="user.role == 'admin'" class="col-xl-4 col-md-6 mb-4" href="/dashboard/blog/post">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body pb-0">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Blogs</div>
                <div class="h3 mb-0 font-weight-bold text-gray-800">{{ blogs.published + blogs.unpublished }}</div>
              </div>
              <div class="col-auto">
                <i class="icofont-rss-feed icofont-3x text-gray-800"></i>
              </div>
            </div>
            <div class="row no-gutters position-relative mt-2">
              <span class="status published pr-4" title="blogs that are published to site"
                ><b>{{ blogs.published }}</b> Published</span
              >
              <span class="status unpublished pr-4" title="blogs that are not published to site"
                ><b>{{ blogs.unpublished }}</b> Unpublished</span
              >
            </div>
            <hr class="row" />
            <div class="row no-gutters">
              <p class="mb-0 small text-muted">The number of blogs written and their status</p>
            </div>
          </div>
        </div>
      </a>

      <!-- destination statistics -->
      <a v-if="user.role == 'admin'" class="col-xl-4 col-md-6 mb-4" href="/dashboard/destination/post">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body pb-0">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Destinations</div>
                <div class="h3 mb-0 font-weight-bold text-gray-800">
                  {{ destinations.published + destinations.unpublished }}
                </div>
              </div>
              <div class="col-auto">
                <i class="icofont-location-pin icofont-3x text-gray-800"></i>
              </div>
            </div>
            <div class="row no-gutters position-relative mt-2">
              <span class="status published pr-4" title="destinations that are published to site"
                ><b>{{ destinations.published }}</b> Published</span
              >
              <span class="status unpublished pr-4" title="destinations that are not published to site"
                ><b>{{ destinations.unpublished }}</b> Unpublished</span
              >
            </div>
            <hr class="row" />
            <div class="row no-gutters">
              <p class="mb-0 small text-muted">The number of destinations written and their status</p>
            </div>
          </div>
        </div>
      </a>

      <!-- landing page statistics -->
      <a v-if="user.role == 'admin'" class="col-xl-4 col-md-6 mb-4" href="/dashboard/landing-page/page">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body pb-0">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Landing Pages</div>
                <div class="h3 mb-0 font-weight-bold text-gray-800">
                  {{ landingPage.published + landingPage.unpublished }}
                </div>
              </div>
              <div class="col-auto">
                <i class="icofont-bullhorn icofont-3x text-gray-800"></i>
              </div>
            </div>
            <div class="row no-gutters position-relative mt-2">
              <span class="status published pr-4" title="landing pages that are published to site"
                ><b>{{ landingPage.published }}</b> Published</span
              >
              <span class="status unpublished pr-4" title="landing pages that are not published to site"
                ><b>{{ landingPage.unpublished }}</b> Unpublished</span
              >
            </div>
            <hr class="row" />
            <div class="row no-gutters">
              <p class="mb-0 small text-muted">The number of landing pages written and their status</p>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
const dateFormat = require("dateformat");
import { mapGetters, mapActions } from "vuex";
import VueGauge from "vue-gauge";

export default {
  name: "Dashboard",
  components: { VueGauge },
  computed: {
    ...mapGetters([
      "user",
      "isAuthenticated",
      "quotesStatistics",
      "toursStatistics",
      "operatorsStatistics",
      "reviewStatistics",
      "blogStatistics",
      "destinationStatistics",
      "landingPageStatistics",
    ]),

    quotes() {
      return this.quotesStatistics;
    },

    tours() {
      return this.toursStatistics;
    },

    operators() {
      return this.operatorsStatistics;
    },

    reviews() {
      return this.reviewStatistics;
    },

    blogs() {
      return this.blogStatistics;
    },

    destinations() {
      return this.destinationStatistics;
    },

    landingPage() {
      return this.landingPageStatistics;
    },

    lastLogin() {
      return dateFormat(this.user.lastLogin, "mmm dS, yyyy, h:MM:ss TT");
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await Promise.all([
        this.fetchQuotesStatistics(),
        this.fetchToursStatistics(),
        this.fetchOperatorsStatistics(),
        this.fetchReviewStatistics(),
        this.fetchBlogStatistics(),
        this.fetchDestinationStatistics(),
        this.fetchLandingPageStatistics(),
      ]);

      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions([
      "hideBarLoading",
      "fetchQuotesStatistics",
      "fetchToursStatistics",
      "fetchOperatorsStatistics",
      "fetchReviewStatistics",
      "fetchBlogStatistics",
      "fetchDestinationStatistics",
      "fetchLandingPageStatistics",
    ]),
  },
};
</script>
